import { render } from "./Trackbox.vue?vue&type=template&id=b9270e4a"
import script from "./Trackbox.vue?vue&type=script&lang=js"
export * from "./Trackbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__